<div style="width: 100%;">
  <form [formGroup]="addDescriptionToTicketForm">
    <h2 matDialogTitle>Add new description</h2>
    
    <mat-dialog-content>
      <app-upload-files #fileUpload></app-upload-files>
      <mat-form-field hintLabel="Max 5000 characters" class="input-group">
        <textarea [maxLength]="5000" matInput formControlName="pde_description" placeholder="e.g. user responses, annotations, information" style="height: 500px;"
          (keydown)="onTextareaKeydown($event)" [disabled]="!isLoading"></textarea>
      </mat-form-field>

      <div class="input-group">
        <mat-radio-group formControlName="pde_type" [disabled]="!isLoading">
          <mat-radio-button color="primary" value="Support">Support</mat-radio-button>
          <mat-radio-button color="primary" value="User">User</mat-radio-button>
          <mat-radio-button color="primary" value="Solution">Solution</mat-radio-button>
        </mat-radio-group>
      </div>


    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-flat-button (click)="onCancel()" [disabled]="isLoading">Cancel</button>
      <button mat-raised-button color="primary" (click)="onAddDescriptionToTicket()" [disabled]="isLoading">Save</button>
    </mat-dialog-actions>
  </form>
</div>